<div class="response-to-rca-container">
    <div class="dialog-content-wrapper">
        <div class="top-controls">
            <button pButton type="button" label="Go back" class="p-button-secondary go-back-button"
                (click)="goBack.emit()"></button>
            <div class="step-indicator">
                <div class="step">
                    <span class="step-number">1</span>
                    <span class="step-text">GRS Filled Details</span>
                </div>
                <div class="step-line"></div>
                <div class="step active">
                    <span class="step-number">2</span>
                    <span class="step-text">User Details</span>
                </div>
            </div>
        </div>

        <div class="form-content">
            <form [formGroup]="rcaForm" autocomplete="off">
                <!-- Top two fields, always visible -->
                 <div class="parent-question-grid">
                     <div class="form-grid device-classification-impact-grid"> 
                         <div class="form-group">
                             <label for="deviceClassification">Device classification in country</label>
                             <p-dropdown id="deviceClassification" [options]="deviceClassificationsOptions"
                                 optionLabel="name" [filter]="true" formControlName="deviceClassification"
                                 placeholder="Select Device Classification in country" [appendTo]="'body'"
                                 [ngClass]="{ 'ng-invalid ng-dirty': formSubmitted && rcaForm.controls['deviceClassification'].invalid }"></p-dropdown>
                         </div>
                         <div class="form-group">
                             <label for="impactConclusion">Impact Conclusion <span class="required">*</span></label>
                             <p-dropdown id="impactConclusion" [options]="impactConclusionOptions" optionLabel="name"
                             [filter]="true" formControlName="impactConclusion" placeholder="Select Impact Conclusion"
                             [appendTo]="'body'"
                             [ngClass]="{ 'ng-invalid ng-dirty': formSubmitted && rcaForm.controls['impactConclusion'].invalid }"></p-dropdown>
                         </div>
                     </div>
                     <div class="device-classification-impact-grid">
                         <div class="form-group full-width impact-assess-justify-group">
                             <label for="assessmentAndJustification">Impact assessment and justification <span
                                     class="required">*</span></label>
                             <div
                                 class="change-description-editor-shell impact-assess-text-shell"
                                 *ngIf="!impactAssessJustificationMaxPreview"
                                 [class.change-description-editor-shell--invalid]="impactAssessJustificationInvalid"
                             >
                                 <div class="change-description-editor-chrome-header">
                                     <button
                                         type="button"
                                         pButton
                                         icon="pi pi-window-maximize"
                                         class="p-button-text p-button-rounded p-button-sm change-description-editor-chrome-btn"
                                         pTooltip="Open maximized editor"
                                         tooltipPosition="left"
                                         (click)="openImpactAssessJustificationMaxPreview()"
                                         aria-label="Open impact assessment and justification in maximized editor"
                                     ></button>
                                 </div>
                                 <textarea
                                     id="assessmentAndJustification"
                                     pInputTextarea
                                     rows="3"
                                     formControlName="assessmentAndJustification"
                                     placeholder="Enter impact assessment and justification"
                                     [ngClass]="{ 'ng-invalid ng-dirty': impactAssessJustificationInvalid }"
                                 ></textarea>
                             </div>
                         </div>
                     </div>
                 </div>

                <!-- Conditional fields based on Impact Conclusion -->
                <ng-container *ngIf="rcaForm.get('impactConclusion')?.value?.name">
                    <!-- Fields shown ONLY if Impact Conclusion is 'Yes' -->
                    <ng-container *ngIf="rcaForm.get('impactConclusion')?.value?.name === 'Yes'">
                        <div class="form-grid">
                            <div class="form-group">
                                <label for="documentationRequired">Select the documentation required to support the
                                    changes? <span class="required">*</span></label>
                                <p-multiSelect id="documentationRequired" [options]="documentationOptions"
                                    optionLabel="name" formControlName="documentationRequired"
                                    placeholder="Select Documents" [appendTo]="'body'" [filter]="true"
                                    [ngClass]="{ 'ng-invalid ng-dirty': formSubmitted && rcaForm.controls['documentationRequired'].invalid }"></p-multiSelect>
                            </div>
                            <div class="form-group" *ngIf="showOtherDocumentationField">
                                <label for="otherDocumentationInput">Please specify other documentation <span class="required">*</span></label>
                                <input id="otherDocumentationInput" type="text" pInputText
                                    formControlName="otherDocumentationInput"
                                    placeholder="Enter other documentation details"
                                    [ngClass]="{ 'ng-invalid ng-dirty': formSubmitted && rcaForm.controls['otherDocumentationInput'].invalid }" />
                            </div>
                            <div class="form-group">
                                <label for="timeLocalRegulatory">Time required for local Regulatory to prepare
                                    submissions (Days) <span class="required">*</span></label>
                                <div class="p-inputgroup">
                                    <input id="timeLocalRegulatory" type="number" pInputText
                                        formControlName="timeLocalRegulatory" placeholder="Enter number of days"
                                        [ngClass]="{ 'ng-invalid ng-dirty': formSubmitted && rcaForm.controls['timeLocalRegulatory'].invalid }" />
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="timeHealthAuthority">Time required for Health Authority to review & approve.
                                    (Days) <span class="required">*</span></label>
                                <div class="p-inputgroup">
                                    <input id="timeHealthAuthority" type="number" pInputText
                                        formControlName="timeHealthAuthority" placeholder="Enter number of days"
                                        [ngClass]="{ 'ng-invalid ng-dirty': formSubmitted && rcaForm.controls['timeHealthAuthority'].invalid }" />
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="productAuthority">Will you accept the modified product/operation manual
                                    prior to Health Authority approval? <span class="required">*</span></label>
                                <p-dropdown id="productAuthority" [options]="yesNoOptions" optionLabel="name"
                                    formControlName="productAuthority" placeholder="Select an option"
                                    [appendTo]="'body'"
                                    [ngClass]="{ 'ng-invalid ng-dirty': formSubmitted && rcaForm.controls['productAuthority'].invalid }"></p-dropdown>
                            </div>
                            <div class="form-group">
                                <label for="productNotify">For Product Changes, after notification/Health Authority
                                    approval, will you accept both products on the market, (old and new version)? <span
                                        class="required">*</span></label>
                                <p-dropdown id="productNotify" [options]="yesNoOptions" optionLabel="name"
                                    formControlName="productNotify" placeholder="Select an option" [appendTo]="'body'"
                                    [ngClass]="{ 'ng-invalid ng-dirty': formSubmitted && rcaForm.controls['productNotify'].invalid }"></p-dropdown>
                            </div>
                            <div class="form-group full-width impact-assess-justify-group" *ngIf="rcaForm.get('productNotify')?.value?.name === 'Yes'">
                                <label for="timeProductNotify">For how long can you accept both old and new versions of products on the market? (Days)<span
                                        class="required">*</span></label>
                                <div
                                    class="change-description-editor-shell impact-assess-text-shell"
                                    *ngIf="!acceptableDurationMaxPreview"
                                    [class.change-description-editor-shell--invalid]="timeProductNotifyInvalid"
                                >
                                    <div class="change-description-editor-chrome-header">
                                        <button
                                            type="button"
                                            pButton
                                            icon="pi pi-window-maximize"
                                            class="p-button-text p-button-rounded p-button-sm change-description-editor-chrome-btn"
                                            pTooltip="Open maximized editor"
                                            tooltipPosition="left"
                                            (click)="openAcceptableDurationMaxPreview()"
                                            aria-label="Open acceptable duration in maximized editor"
                                        ></button>
                                    </div>
                                    <textarea
                                        id="timeProductNotify"
                                        pInputTextarea
                                        rows="3"
                                        formControlName="timeProductNotify"
                                        placeholder="Please specify the timelines"
                                        [ngClass]="{ 'ng-invalid ng-dirty': timeProductNotifyInvalid }"
                                    ></textarea>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <!-- Fields always shown if Impact Conclusion is selected (Yes or No) -->
                    <div class="form-grid">
                        
                    </div>
                    <div class="form-group additional-attachments-group">
                        <label for="additionalAttachments">Additional Attachments (optional)</label>
                        <div class="attachment-upload-container">
                            <textarea id="additionalAttachments" pInputTextarea rows="2"
                                placeholder="Description about the files uploaded"
                                formControlName="additionalAttachments" class="attachment-description"></textarea>
                            <!-- Hidden file input -->
                            <input #fileInput type="file" multiple class="hidden-file-input" (change)="onFileSelect($event)"
                                accept=".pdf,.doc,.docx,.xlsx,.pptx,.png,.jpg,.jpeg" />

                            <div class="upload-area">
                                <button pButton type="button" label="Add File" icon="pi pi-upload"
                                    class="p-button-warning upload-button" (click)="openFileSelector()"
                                    [disabled]="uploading" pTooltip="Supported: PDF, DOC, DOCX, XLSX, PPTX, PNG, JPG, JPEG. Max size 5 MB each"
                                    tooltipPosition="top"></button>
                                <small *ngIf="uploadError" class="p-error">{{ uploadError }}</small>
                            </div>

                            <div class="attachments-list" *ngIf="uploadedFiles.length">
                                <div class="attachment-item" *ngFor="let file of uploadedFiles">
                                    <i class="pi pi-file mr-2"></i>
                                    <span class="file-name" [pTooltip]="file.name" tooltipPosition="top">{{ file.name }}</span>
                                    <span class="file-status" *ngIf="file.uploading"><i class="pi pi-spin pi-spinner"></i> Uploading...</span>
                                    <span class="file-status success" *ngIf="file.uploaded && !file.uploading"><i class="pi pi-check-circle"></i> Uploaded</span>
                                    <span class="file-status error" *ngIf="file.error"><i class="pi pi-exclamation-triangle"></i> {{ file.error }}</span>
                                    <button pButton type="button" icon="pi pi-download" class="p-button-text p-button-sm"
                                        (click)="downloadUploadedOrLocal(file)"
                                        [disabled]="file.uploading || (!file.uploaded && !file.localBlobUrl)"
                                        pTooltip="Download"></button>
                                    <button pButton type="button" icon="pi pi-trash" class="p-button-text p-button-danger p-button-sm"
                                        (click)="removeFile(file)" [disabled]="file.uploading" pTooltip="Remove"></button>
                                </div>
                            </div>

                            <div *ngIf="!uploadedFiles.length" class="no-files-placeholder">
                                <small>No files uploaded yet.</small>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </form>
        </div>
    </div>
</div>

<p-dialog
    [(visible)]="impactAssessJustificationMaxPreview"
    [modal]="true"
    [dismissableMask]="true"
    [draggable]="false"
    [resizable]="false"
    [maximizable]="false"
    [showHeader]="false"
    [closable]="false"
    position="top"
    [appendTo]="'body'"
    styleClass="change-description-max-dialog change-description-max-dialog--editor impact-assess-max-dialog--textarea"
    [contentStyle]="impactAssessJustificationMaxDialogContentStyle"
>
    <div *ngIf="impactAssessJustificationMaxPreview" [formGroup]="rcaForm" class="change-description-max-editor-host">
        <div
            class="change-description-editor-shell change-description-editor-shell--max-dialog impact-assess-text-shell"
            [class.change-description-editor-shell--invalid]="impactAssessJustificationInvalid"
        >
            <div class="change-description-editor-chrome-header change-description-editor-chrome-header--dialog">
                <span class="change-description-editor-chrome-title">Impact assessment and justification</span>
                <button
                    type="button"
                    pButton
                    icon="pi pi-window-minimize"
                    class="p-button-text p-button-rounded p-button-sm change-description-editor-chrome-btn"
                    pTooltip="Exit maximized editor"
                    tooltipPosition="left"
                    (click)="closeImpactAssessJustificationMaxPreview()"
                    aria-label="Exit maximized impact assessment and justification editor"
                ></button>
            </div>
            <textarea
                id="assessmentAndJustificationMaximized"
                pInputTextarea
                formControlName="assessmentAndJustification"
                placeholder="Enter impact assessment and justification"
                [style]="impactAssessJustificationMaxTextareaStyle"
                [ngClass]="{ 'ng-invalid ng-dirty': impactAssessJustificationInvalid }"
            ></textarea>
        </div>
    </div>
</p-dialog>

<p-dialog
    [(visible)]="acceptableDurationMaxPreview"
    [modal]="true"
    [dismissableMask]="true"
    [draggable]="false"
    [resizable]="false"
    [maximizable]="false"
    [showHeader]="false"
    [closable]="false"
    position="top"
    [appendTo]="'body'"
    styleClass="change-description-max-dialog change-description-max-dialog--editor impact-assess-max-dialog--textarea"
    [contentStyle]="impactAssessJustificationMaxDialogContentStyle"
>
    <div *ngIf="acceptableDurationMaxPreview" [formGroup]="rcaForm" class="change-description-max-editor-host">
        <div
            class="change-description-editor-shell change-description-editor-shell--max-dialog impact-assess-text-shell"
            [class.change-description-editor-shell--invalid]="timeProductNotifyInvalid"
        >
            <div class="change-description-editor-chrome-header change-description-editor-chrome-header--dialog">
                <span class="change-description-editor-chrome-title">For how long can you accept both old and new versions of products on the market? (Days)</span>
                <button
                    type="button"
                    pButton
                    icon="pi pi-window-minimize"
                    class="p-button-text p-button-rounded p-button-sm change-description-editor-chrome-btn"
                    pTooltip="Exit maximized editor"
                    tooltipPosition="left"
                    (click)="closeAcceptableDurationMaxPreview()"
                    aria-label="Exit maximized acceptable duration editor"
                ></button>
            </div>
            <textarea
                id="timeProductNotifyMaximized"
                pInputTextarea
                formControlName="timeProductNotify"
                placeholder="Please specify the timelines"
                [style]="impactAssessJustificationMaxTextareaStyle"
                [ngClass]="{ 'ng-invalid ng-dirty': timeProductNotifyInvalid }"
            ></textarea>
        </div>
    </div>
</p-dialog>